import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState } from 'react';
import { FilesAlt, Link, Link45deg } from 'react-bootstrap-icons';
import { BiDownload } from 'react-icons/bi';
import { BsReplyFill } from 'react-icons/bs';
import { RiAttachment2 } from 'react-icons/ri';
import DateTimePickerFunctions from '../../../../components/ui/calendar/date_picket/DateTimePickerComponents/DateTimePickerFunctions';
import Messaging from '../../../../libs/api/services/Messaging';
import WorkFlow from '../../../../libs/api/services/WorkFlow';
import FlattenedHash from '../../../../libs/templating/FlattenedHash';
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider';
import UserSearchBar from '../../../search/UserSearchBar';
import WorkFlowDetailsScreen from '../../workflow/management/WorkFlowDetailsScreen';
import RTEMessageBuilderComponent from '../admin/components/RTEMessageBuilderComponent';

export default function MessageModal({ message }) {
    const [tMessage, setTMessage] = useState(message)
    const [error, setError] = useState()
    const [messageBody, setMessageBody] = useState()
    const Flatten = new FlattenedHash(message, 'Message', {
        'Message|sentDate': (s) => { return DateTimePickerFunctions.LocalISO(new Date(s), 'h') },
        'Message|receviedDate': (s) => { return DateTimePickerFunctions.LocalISO(new Date(s), 'h') }
    })

    useEffect(() => { setTMessage(message) }, [message])

    useEffect(() => {
        const load = async () => {
            try {
                const m = await Messaging.GetMessage(tMessage.id).catch(e => setError(e))
                // This is to include new attachments
                setTMessage(m)
                setMessageBody(m.messageBody.body)
            } catch (e) { }
        }
        load()

    }, [])
    return (
        <div className='text-dark d-flex flex-column' style={{ maxHeight: '100%', overflow: 'hidden' }}  >
            {/* <pre>
                {JSON.stringify(new FlattenedHash(message, 'Message').GetResult(), '\t', 2)}
            </pre> */}
            <div className='shadow d-flex flex-column'>
                <div className='d-flex flex-shrink-1'>
                    <div className='flex-grow-1 w-50' dangerouslySetInnerHTML={{
                        __html:
                            Flatten.FromMustache(`<b>Sent From </b>
                            {{#Message|fromUser|firstName}}
                            {{{.}}} {{Message|fromUser|lastName}}
                            {{/Message|fromUser|firstName}}
                            {{#Message|from}}&lt;{{Message|from}}&gt;{{/Message|from}} 
                            `)
                    }} />
                    <div className='flex-grow-1 w-50' dangerouslySetInnerHTML={{
                        __html:
                            Flatten.FromMustache(`<b>Sent To </b>
                            {{#Message|toUser|firstName}}
                            {{{.}}} {{Message|toUser|lastName}}
                            {{/Message|toUser|firstName}}
                            {{#Message|to}}&lt;{{{.}}}&gt;{{/Message|to}} 
                            `)
                    }} />
                </div>
                <div className='d-flex flex-grow-1'>
                    <div className='flex-grow-1 w-50' dangerouslySetInnerHTML={{
                        __html:
                            Flatten.FromMustache(`{{#Message|sentDate}}<b>Sent On </b>{{{.}}}{{/Message|sentDate}}`)
                    }} />
                    <div className='flex-grow-1 w-50' dangerouslySetInnerHTML={{
                        __html:
                            Flatten.FromMustache(`{{#Message|receviedDate}}<b>Received On </b>{{{.}}}{{/Message|receviedDate}}`)
                    }} />
                </div>
                <div className='d-flex'>
                    <div className='flex-grow-1' dangerouslySetInnerHTML={{
                        __html:
                            Flatten.FromMustache(`{{#Message|subject}}<b>Subject </b>{{{.}}}{{/Message|subject}}`)
                    }} />
                </div>
                <div className='d-flex'>
                    <div className='flex-grow-1' dangerouslySetInnerHTML={{
                        __html:
                            Flatten.FromMustache(`{{#Message|serviceType|type}}<b>Sent via </b>{{{.}}}{{/Message|serviceType|type}}`)
                    }} />
                </div>
                <MessageLinkBar message={tMessage} setError={setError} />

            </div>
            <div style={{ overflow: 'auto', maxHeight: '100%' }}>
                {error && <div className='bg-danger-container text-center p-2 shadow m-1'>{error.message}</div>}
                {messageBody && <div dangerouslySetInnerHTML={{ __html: messageBody }} />}
            </div>
        </div>
    )
}


const MessageLinkBar = ({ message, setError }) => {
    const { createModal } = useContext(CommonFunctionsContext)
    const [show, setShow] = useState()


    return (<div className='align-items-start justify-content-start '>
        <div className='d-flex '>
            <button onClick={e => setShow(show && show === 'Links' ? undefined : 'Links')} className={`btn text-start rounded-0 rounded-top-3 ${show === 'Links' && 'bg-primary-container'}`}>
                <Link /> Links
            </button>
            {message.attachments && message.attachments.length > 0 && <button onClick={e => setShow(show && show === 'Attachments' ? undefined : 'Attachments')} className={`btn text-start rounded-0 rounded-top-3 ${show === 'Attachments' && 'bg-primary-container'}`}>
                <RiAttachment2 /> {`Attachments ${message.attachments && `(${message.attachments.length})`}`}
            </button>}
            <button onClick={e => setShow(show && show === 'Reply' ? undefined : 'Reply')} className={`btn d-flex align-items-center text-start rounded-0 rounded-top-3 ${show === 'Reply' && 'bg-primary-container'}`}>
                <BsReplyFill />Reply
            </button>
        </div>
        <div className={`d-flex flex-column ${show ? 'slide-down' : 'slide-up'}`}>
            <div className={`d-flex flex-column w-100 bg-primary-container`}>
                {
                    {
                        'Links': <LinksDropDown message={message} />,
                        'Attachments': <AttachmentsDropDown message={message} setError={setError} />,
                        'Reply': <ReplyDropDown message={message} setError={setError} />
                    }[show]
                }

            </div>
        </div>
    </div>)
}

const AttachmentsDropDown = ({ message, setError }) => {
    const { createModal } = useContext(CommonFunctionsContext)
    const [loading, setLoading] = useState(false)
    // return (JSON.stringify(message.attachments))

    const base64ToFile = (base64String, mimeType, fileName) => {
        // Remove the data URL scheme if present
        const base64Data = base64String.replace(/^data:.+;base64,/, '');
        const byteCharacters = atob(base64Data); // Decode Base64 string
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
        const url = URL.createObjectURL(blob);

        // Create a link element to download the file
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();

        // Cleanup
        URL.revokeObjectURL(url);
    }

    const _handleShowAttachment = async (attachment) => {
        setLoading(true)
        const data = await Messaging.GetAttachment(attachment.id).catch(e => setError(e.message))
        createModal(<>
            {/* {JSON.stringify(r.data)} */}
            <div className='flex-shrink-1 d-flex justify-content-center'>
                <div className='w-50'>
                    <div><b>Name:</b> {attachment.fileName}</div>
                    <div><b>Type:</b> {attachment.mimeType}</div>
                </div>
                <div className='w-50 d-flex justify-content-end'>
                    <button onClick={e => base64ToFile(data.data, attachment.mimeType, attachment.fileName)} className='btn d-flex align-items-center'>
                        <BiDownload className='me-2' size={30} />
                        <b>Download</b>
                    </button>
                </div>
            </div>
            <div className='flex-grow-1'>
                {
                    {
                        "image": <img src={`data:${attachment.mimeType};base64,${data.data}`} alt={attachment.fileName} />,
                        "video": <video src={`data:${attachment.mimeType};base64,${data.data}`} alt={attachment.fileName} />,
                    }[attachment.mimeType.substring(0, attachment.mimeType.indexOf('/'))] ||
                    {
                        "/pdf": <embed style={{ width: attachment.mimeType.includes('image') ? 'auto' : '100%', height: attachment.mimeType.includes('image') ? 'auto' : '100%' }} type={attachment.mimeType} src={`data:${attachment.mimeType};base64,${data.data}`} />
                    }[attachment.mimeType.substring(attachment.mimeType.indexOf('/'))] || <div className='h-100 d-flex flex-column align-items-center justify-content-center'>
                        <FilesAlt size={50} />
                        <h3>Previewing is not supported for this file type.</h3>
                        To open this file download it and open it locally
                    </div>
                    //`Unsupported type ${attachment.mimeType.substring(attachment.mimeType.indexOf('/'))}`
                }
            </div>
        </>, `${message.subject} : ${attachment.fileName}`
        )
        setLoading(false)

    }
    if (loading) return <div className='p-2 shadow mb-2 rounded'><FontAwesomeIcon icon={faSpinner} spin /> Loading</div>
    return (message.attachments.map(a =>
        <div style={{ cursor: 'pointer' }} key={a.id} onClick={e => _handleShowAttachment(a)} className='p-2 shadow mb-2 rounded'>{a.fileName}</div>
    ))
}
const LinksDropDown = ({ message }) => {
    const { createModal, showConfirm } = useContext(CommonFunctionsContext)
    const [links, setLinks] = useState()

    const loadLinks = async () =>
        setLinks(await WorkFlow.GetWorkFlowHistoryMessages(message.id))

    useState(() => {
        loadLinks()
    }, [])

    const _handleUnlink = (ev, e) => {
        ev.preventDefault()
        ev.stopPropagation()
        showConfirm({
            children: 'Are you sure you would like to unlink this message?',
            onCancel: () => { },
            onConfirm: () => { WorkFlow.LinkMessageToWorkFlow(e.id, message.id).then(r => loadLinks()) },
        })
    }
    const _handleShowWF = (ev, e) => {
        ev.preventDefault()
        ev.stopPropagation()
        createModal(<WorkFlowDetailsScreen id={e.id} />)
        // WorkFlowDetailsScreen
    }

    return (<>
        <button
            onClick={e => createModal(<MessageLinkToEventModal message={message} />, 'Linking message to event', null, () => loadLinks())}
            className='btn text-start align-self-center'><Link45deg />Link message to event</button>
        {links &&
            links.map(e =>
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={ev => _handleShowWF(ev, e)}
                    key={e.id} className={`d-flex rounded mb-2 shadow p-2 w-100 align-items-center`}>
                    <div className='flex-grow-1'>{`${e.wfEvent && e.wfEvent.name}`}</div>
                    {e.triggeredBy && <div className='text-start w-25'>{`${e.triggeredBy.firstName} ${e.triggeredBy.lastName}`}</div>}
                    {e.triggeredFor && <div className='text-start w-25'>{`${e.triggeredFor.firstName} ${e.triggeredFor.lastName}`}</div>}
                    <div className='text-start w-25'>{`${DateTimePickerFunctions.LocalISO(new Date(e.triggeredDateTime), 'h')}`}</div>
                    <div className='text-start '>
                        {e.wfEvent && <button onClick={ev =>
                            _handleUnlink(ev, e)} className='btn'><Link45deg /></button>}
                    </div>
                </div>)
            // JSON.stringify(links)
        }
    </>)
}
const ServiceTypeOptions = {
    'Internal Messaging Service': ['fontSize', 'inline', 'textAlign', 'emoji'],
    'SMS': ['emoji'],
    'WhatsApp': ['emoji'],
    'Email': ['fontSize', 'inline', 'textAlign', 'emoji'],
}
const ReplyDropDown = ({ message, setError }) => {
    const [reply, setReply] = useState()
    const [status, setStatus] = useState()

    const _handleSendMessage = async () => {
        setStatus({
            success: true,
            message: 'Sending Reply . . .'
        })
        const res = await Messaging.SendReply(message.id, reply)
            .catch(e => {
                setStatus({
                    success: false,
                    message: e.message ? e.message : 'Failed to to send reply'
                })
            });
        if (res)
            setStatus({
                success: true,
                message: 'Message Sent'
            })
    }
    return (<div className='bg-light text-dark'>
        {
            status ? <div className={`bg-${status.success ? 'success' : 'danger'}-container text-center p-2 shadow`}>{status.message} {!status.success && <button onClick={e => setStatus()} className='btn btn-xs'>Retry</button>}</div>
                :
                <>
                    <RTEMessageBuilderComponent
                        disablePlaceholders={true}
                        placeholders={false}
                        // onSetTemplate={(t, h, m) => { }}
                        onSetTemplate={(t, h, m) => setReply({
                            ...reply,
                            template: t,
                            templateHTML: h,
                            templateMD: m.replaceAll('**', '')
                        })}
                        options={ServiceTypeOptions[message.serviceType]}
                        viewOnly={false} />
                    <div className='flex-shrink-1 d-flex justify-content-end'>
                        <button
                            onClick={() => _handleSendMessage()}
                            className={'btn bg-secondary-container bg-transparent'}>Send</button>
                    </div>
                </>
        }

    </div>)
}
const MessageLinkToEventModal = ({ message, close }) => {
    const { showToast } = useContext(CommonFunctionsContext)
    const [state, setState] = useState({
        user: undefined,
        events: undefined,
        event: undefined
    })

    useEffect(() => {
        const load = async () =>
            setState({ ...state, events: await WorkFlow.GetUserWorkFlowHistory(state.user) })
        if (state.user)
            load()
    }, [state.user])

    const _handleLinkEvent = () => {
        WorkFlow.LinkMessageToWorkFlow(state.event.id, message.id)
            .then((r) =>
                close(() =>
                    showToast('Message linked to event', <Link45deg />, 5)
                )
            );

    }

    return (<div className='d-flex flex-column h-100'>
        <div className='m-3 flex-shrink-1'>
            <div className='w-50'><b>Who did this event happen to?</b></div>
            <div className='w-100'><UserSearchBar noAdd showFull onUserSelected={id => setState({ ...state, user: id })} /></div>
        </div>
        {typeof state.events !== 'undefined' &&
            <div className='mx-3 flex-shrink-1'>
                <b>Select the event:</b>
            </div>
        }
        <div className='m-3 flex-grow-1' style={{ overflow: 'auto' }}>
            {typeof state.events !== 'undefined' && <div>

                {state.events.map(e =>
                    <div onClick={ev => setState({ ...state, event: e })} key={e.id} className={`d-flex rounded mb-2 shadow p-2 ${state.event && state.event.id === e.id ? 'bg-primary-container' : ''}`}>
                        <div className='flex-grow-1'>{`${e.wfEvent && e.wfEvent.name}`}</div>
                        <div className='text-start w-25'>{`${DateTimePickerFunctions.LocalISO(new Date(e.triggeredDateTime), 'h')}`}</div>
                    </div>)}
            </div>
            }
        </div>
        <div className='m-3 text-center flex-shrink-1'>
            {state.event && <button onClick={_handleLinkEvent} className='btn bg-primary-container'>Link</button>}
        </div>
    </div>)
}